import { createAuthContext } from "./AuthContext.js";
import { createAuthProvider } from "./AuthProvider/AuthProvider.js";
import { createUseAuth } from "./useAuth.js";
function createAuthentication(authImplementation, customProviderHooks) {
  const AuthContext = createAuthContext();
  const useAuth = createUseAuth(AuthContext);
  const AuthProvider = createAuthProvider(
    AuthContext,
    authImplementation,
    customProviderHooks
  );
  return { AuthContext, AuthProvider, useAuth };
}
export {
  createAuthentication
};
